import {createGlobalStyle} from "styled-components";
import { Blue, White } from "./colors";

export const GlobalStyle = createGlobalStyle`
  body {
    font-family: 'Inter', sans-serif;
    margin: auto;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

::-webkit-scrollbar {
    width: 2px; /* Width of the vertical scrollbar */
    height: 2px; /* Height of the horizontal scrollbar */
}

/* Customize the scrollbar track */
::-webkit-scrollbar-track {
    background: ${White} /* Color of the track */
}

/* Customize the scrollbar thumb */
::-webkit-scrollbar-thumb {
    background: ${Blue}; /* Color of the thumb */
}

/* Hover effect for the scrollbar thumb */
::-webkit-scrollbar-thumb:hover {
    background: #555; /* Color of the thumb on hover */
}

`;
